
















































/** @format */

import { Vue, Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import { DEFAULT_DATE_FORMAT } from '@root/common/config';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { IFieldInfoListItem } from '@root/types/component';
// axios请求
import { getAccountdetail } from '@/api/discount-management/index';
// import FieldInfoList from '@/frame/src/components/field-info-list/index.vue'

@Component
export default class BusinessInformation extends Mixins(TableMixin, TableWidthMixin) {
  @Prop()
  getAllDetailList!: any;

  @Prop()
  id!: any;

  tableData: any[] = [];
  detailList = {};
  businessinfoList1: IFieldInfoListItem[] = [
    {
      prop: 'name',
      label: '商家名称 ：'
    },
    {
      prop: 'typeName',
      label: '商户类型 ：'
    },
    {
      prop: 'orgdepName',
      label: '所属机构 ：'
    },
    {
      prop: 'parkName',
      label: '适用车场 ：'
    },
    {
      prop: 'linkman',
      label: '联系人 ：'
    },
    {
      prop: 'mobile',
      label: '手机号 ：'
    },
    {
      prop: 'createBy',
      label: '创建人 ：'
    },
    {
      prop: 'createTime',
      label: '创建时间 ：'
    },
    {
      prop: 'updateTime',
      label: '修改时间 ：'
    }
  ];
  businessinfoList2: IFieldInfoListItem[] = [
    {
      prop: 'companyName',
      label: '公司名称 ：'
    },
    {
      prop: 'saleCode',
      label: '纳税人识别号 ：'
    },
    {
      prop: 'invoiceTypeName',
      label: '发票类型 ：'
    },
    {
      prop: 'saleAddress',
      label: '注册地址 ：'
    },
    {
      prop: 'saleTel',
      label: '注册电话 ：'
    },
    {
      prop: 'saleBank',
      label: '开户银行 ：'
    },
    {
      prop: 'saleBankNo',
      label: '银行账号 ：'
    },
    {
      prop: 'email',
      label: '电子发票接收邮箱 ：'
    }
  ];
  created() {
    console.log(this.$route.params.deviceId);
    // @ts-ignore
    this.deviceId = this.$route.params.deviceId;
    // this.renderDetail(this.$route.params.deviceId)
    this.fetchTableData();
  }

  async fetchTableData(isRefresh?: boolean) {
    console.log(this.dateTime);
    if (this.tableLoading) return;
    // @ts-ignore
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    if (!this.id) return;
    try {
      const res = await getAccountdetail({
        id: this.id,
        currPage: this.current,
        pageSize: this.pageSize
      });
      console.log(res);
      const { data } = res;
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      // const { datas = [], totalNum = 0 } = data || {}
      this.tableData = data.datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      // @ts-ignore
      this.tableLoading = false;
    }
  }
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '账号',
        dataIndex: 'ukLoginId',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '姓名',
        dataIndex: 'linkman',
        width: 140
      },
      {
        title: '手机号',
        dataIndex: 'mobile',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 260,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '最后修改时间',
        dataIndex: 'updateTime',
        width: 260,
        scopedSlots: { customRender: 'text-ellipse-16' }
      }
    ];
  }
}
